import { Component, OnInit, ElementRef, ViewChild, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { SearchFilterService } from '../Services/search-filter.service';
import { Podcast, SearchStaticContent } from '../Models/common.model';
import { paginate } from '../Models/common.pagination';
import { PodcastModalComponent } from './podcast-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'podcast-list',
  templateUrl: './podcast-list.component.html',
    styleUrls: [],
  providers: [SearchFilterService]
})
export class PodcastListComponent implements OnInit {
    private _podcast: Podcast[];
    get podcast(): Podcast[] {
        return this._podcast;
    }
    set podcast(value: Podcast[]) {
        this._podcast = value;
        this.setPage(this.podcast);
    }
    private _staticContent: SearchStaticContent;
    get staticContent(): SearchStaticContent {
        return this._staticContent;
    }
    set staticContent(value: SearchStaticContent) {
        this._staticContent = value;
    }
    cacheFilterNewsarticles: Podcast[] = [];

    filteredPodcast: Podcast[] = [];
    searchedPodcast: Podcast[] = [];
    podcastUrl: string;
    Transcript: string;
    pageOfItems: Array<any>;
    page = 1;
    pageSize = 10; //No of pages per page
    maxPages = 10;
    startIndex: number;
    endIndex: number;
    pager: any = {};
    noSearchText: string;
    loadingText: boolean;
    filterbyValues: any[];
    selectedFilter: any;

    public _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
        sessionStorage.setItem('searchText', (this._searchText != null || this._searchText != undefined) ? this._searchText : "");
        this.performSearch(this.searchText);
    }

    @ViewChild('openPodcast') openModal: ElementRef;
    @ViewChild('txtSearch') searchInput: ElementRef;
    

    constructor(public dataService: SearchFilterService, private modalService: NgbModal,
        private changeDetectorRef: ChangeDetectorRef) {
        var entries: any = performance.getEntriesByType("navigation")[0];
        if (entries.type == "reload" || entries.type == "navigate") {
            sessionStorage.clear();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    ngAfterViewInit() {
        this.dataService.getfilterby().subscribe((data: any[]) => {
            this.filterbyValues = ["No Filter", ...data];
            const filterValue = sessionStorage.getItem('filterIndex') || "0";
            this.selectedFilter = this.filterbyValues[Number(filterValue) == 0 ? 0 : Number(filterValue)];
            var searchtext = sessionStorage.getItem('searchText') || "";
            this._searchText = searchtext;
            if (filterValue == "0") {
                this.podcast = this.cacheFilterNewsarticles;
                this.filteredPodcast = this.cacheFilterNewsarticles;
            }
            else {
                this.filteredPodcast = this.cacheFilterNewsarticles.filter(
                    (podcast: Podcast) => {
                        return this.getfilteredValues(podcast, this.selectedFilter);
                    }
                )
                this.filteredPodcast = this.podcast;
            }
            this.performSearch(searchtext);
            this.setNosearchMessage(this.filteredPodcast);
            if (filterValue == '0' && searchtext == "") {
                this.noSearchText = null;
            }
        });
        
      }

    ngOnInit(): void {
        this.loadingText = true;
        this.page = sessionStorage.getItem('pageIndex') ? parseInt(sessionStorage.getItem('pageIndex')) : 1;
        this.dataService.getPagetitleErrormsg().subscribe((data: SearchStaticContent) => {
            this.staticContent = data;
        })

        this.dataService.getPodcasts().subscribe((data: Podcast[]) => {
            this.podcast = data;
            this.cacheFilterNewsarticles = data;
            this.loadingText = false;
        })

        this.dataService.getfilterby().subscribe((data: any[]) => {
            this.filterbyValues = ["No Filter", ...data];
        })
    }

    performSearch(filterby?: any) {
        if (filterby) {
            if (this.filteredPodcast.length > 1) {
                this.podcast = this.filteredPodcast.filter((podcast: Podcast) => {
                    return this.getfilteredValues(podcast, filterby);
                });
                this.searchedPodcast = this.podcast;
            }
            else {
                this.podcast = this.cacheFilterNewsarticles.filter((podcast: Podcast) => {
                    return this.getfilteredValues(podcast, filterby);
                });
                this.searchedPodcast = this.podcast;
            }
        }
        else {
            if (this.filteredPodcast.length > 1) {
                this.podcast = this.filteredPodcast;
                this.searchedPodcast = this.podcast;
            }
            else {
                this.podcast = this.cacheFilterNewsarticles;
                this.searchedPodcast = this.cacheFilterNewsarticles;
            }
        }
        this.loadingText = false;
        this.setNosearchMessage(this.searchedPodcast);
    }

    setNosearchMessage(podcast: Podcast[]) {
        if (podcast == undefined || podcast.length == 0) {
            this.dataService.getPagetitleErrormsg().subscribe((data: SearchStaticContent) => {
                this.staticContent = data;

            })
            let message = this.staticContent?.NoResultText;
            this.noSearchText = message;
        }
        else {
            this.noSearchText = null;
        }
    }

    getfilteredValues(podcast: Podcast, searchTerm: string): boolean {
        return ((podcast.PodcastTitle != null ? podcast.PodcastTitle.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false) ||
            (podcast.PodcastSummary != null ? podcast.PodcastSummary.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false) ||
            (podcast.PodcastTranscript != null ? podcast.PodcastTranscript.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false)) ||
            (podcast.Tags != null ? podcast.Tags.map(function (t) { return t.toLowerCase(); }).indexOf(searchTerm.toLocaleLowerCase()) !== -1 : false);
    }

    onChangePage(pageOfItems: any) {
        sessionStorage.setItem('pageIndex', pageOfItems)
        // update current page of items and set the number of items on page change
        this.pageOfItems = pageOfItems;
        this.setPage(this.podcast);
    }

    onFilterChange(filterby: any) {
        let selectedOptions = event.target['options'];
        let selectedIndex = selectedOptions.selectedIndex;
        let selectElementText = selectedOptions[selectedIndex].text;
        this.searchInput.nativeElement.value = "";//clear the search input value.
        sessionStorage.setItem('filterIndex', selectedIndex);
        if (selectedIndex == "0") {
            this.podcast = this.cacheFilterNewsarticles;
            this.filteredPodcast = this.cacheFilterNewsarticles;
        }
        else {
            this.podcast = this.cacheFilterNewsarticles.filter(
                (podcast: Podcast) => {
                    return this.getfilteredValues(podcast, selectElementText);
                }
            )
            this.filteredPodcast = this.podcast;
        }
        this.setNosearchMessage(this.filteredPodcast);
    }

    setPage(article: Podcast[]) {
        this.pager = paginate(article.length, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }

    showPodcastPopup(podCast: Podcast) {
        const modalRef = this.modalService.open(PodcastModalComponent, { size: 'lg', scrollable: true  });
        modalRef.componentInstance.podcastUrl = "https://www.buzzsprout.com/469237/" + podCast.PlayerID + ".js?player=small";
        modalRef.componentInstance.Transcript = podCast.PodcastTranscript;
    }

}
